import { useQuery } from '@tanstack/react-query';
import { getLogUploads } from '../../../services/bot-sources/LogUploadService';
import { LogUpload } from '../../../types/bot-sources/LogUpload';
import { LOG_UPLOADS } from '../../query/bot-sources/keys';

export const useGetLogUploads = (projectId: number | null) => {
  const queryEnabled = !!projectId;

  const { data, isLoading, refetch, isError } = useQuery<LogUpload[]>({
    queryKey: [LOG_UPLOADS, projectId],
    queryFn: () => getLogUploads(projectId!),
    staleTime: 1000 * 30,
    gcTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
    enabled: queryEnabled,
  });

  return {
    data: data ?? [],
    isLoading: queryEnabled ? isLoading : false,
    isError,
    refetch,
  };
};
